import type { ReactNode } from "react";
import { motion } from "framer-motion";
import { EASE } from "../../lib/motion";

/** Fades + lifts a section into view the first time it is scrolled to. */
export function Reveal({
  children,
  delay = 0,
  y = 18,
  className = "",
  as = "div",
}: {
  children: ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  as?: "div" | "section";
}) {
  const Comp = as === "section" ? motion.section : motion.div;
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay, ease: EASE.outExpo }}
    >
      {children}
    </Comp>
  );
}
